import React from 'react';
import * as Styles from 'components/manage-vm/settings-panel/SettingsPanel.style';
import { reviewIncluded } from 'components/manage-vm/utils';
import { TickIcon } from 'components/icons';
import { P } from 'components/reusable-css';
import { useSelector } from 'react-redux';
import Heading from 'components/Heading/Heading';

const Features = ({ features }) => {
  const userAccount = useSelector((state) => state.user.account);
  return (
    <Styles.Padding>
      <Heading name={'vs/instance.string89'}>
        <Styles.Step3>
          <Styles.VSOption>
            <Styles.Flex>
              {reviewIncluded(features, userAccount).map((vsOption) => (
                <Styles.VSOptions key={vsOption.id}>
                  <TickIcon />
                  <P style={{ fontWeight: 'bold' }}>{vsOption.name}</P>
                </Styles.VSOptions>
              ))}
            </Styles.Flex>
          </Styles.VSOption>
        </Styles.Step3>
      </Heading>
    </Styles.Padding>
  );
};

export { Features };
